import React from 'react';
import Home from './components/home';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import ServicesPage from './components/Services';
import HealthRecordsPage from './components/HealthRecordsPage';
import AppointmentsPage from './components/appointment';
import PredictForm from './components/Predictions';
import ProfilePage from './components/ProfilePage';
import Login from './components/login';
// import SignUp from './components/signup';
import AIAnalysis from './components/AIAnalysis';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/layout';
import DiseaseDetection from './components/DiseaseDetection';
import LoginForm from './components/auth/LoginForm';
import SignUp from './components/auth/registration';
import PatientRecords from './components/PatientRecords';
import DoctorNavbar from './components/DocNav';
import NewPatients from './components/newpatients'
import { AuthProvider } from './components/context/AuthContext';
import AdminDashboard from './components/AdminDashboard';
// import { Navigate } from 'react-router-dom';

const App = () => {
  return (
    <div>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
      {/* <Route path="/login" element={<Login />} /> */}
          {/* <Route path="/signup" element={<SignUp />} /> */}
          <Route path="/ai-analysis" element={<AIAnalysis />} />
          <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/health-records" element={<HealthRecordsPage />} />
        <Route path="/predictions" element={<PredictForm/>}/>
        <Route path="/appointments" element={<AppointmentsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/disease-detection" element={<DiseaseDetection />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/patients" element={<PatientRecords />} />
        <Route path='/patients/new' element={<NewPatients />} />
        <Route path="/admin" element={<AdminDashboard />} />
        {/* <Route path="*" element={<Navigate to="/" />} /> */}

        </Routes>
    </AuthProvider>
    </div>
  );
};

export default App;